import React from 'react'
import Home from '../components/HomeScreen/Home'

const HomeScreen = () => {
    return (
        <div>
            <Home />
        </div>
    )
}

export default HomeScreen